<template>
    <div class="w-100 h-100">
        <div class="main-time-fileds-wrapper h-100">
            <table class="table comm-table-styles" id="time_settings_table" style="height: 100% !important;background: transparent; overflow: auto;display: block;padding-bottom: 35px;">
                <thead style="color: #eee;display: inline-block;width: 100%;">
                    <tr>
                        <th scope="col" style="width: 20%"></th>
                        <th scope="col" style="width: 80%"></th>
                    </tr>
                </thead>
                <tbody style="display: inline-block;width: 100%;">
                    <tr class='d-flex'>
                        <td class="key-div">{{$t('Time zone')}}</td>
                        <td class="value-div float-left m-0" style="width:60% !important">
                            <div style="display: inline-flex" class="w-100">
                                <div class="w-100" style="display: inline-flex;align-items: center;">
                                    <div class="d-inline-flex" v-if="!isEditting('user_time_zone')">
                                        <span v-show="!isEditting('user_time_zone')">{{selectedTimeZoneValue}}</span>
                                        <edit-icon @click.native="editBasicInfoField('user_time_zone')" v-show="!isEditting('user_time_zone')" class="editIcon"></edit-icon>
                                    </div>
                                    <Multiselect
                                        v-if="isEditting('user_time_zone')"
                                        :value="getTimeZoneMap(selectedTimeZoneValue)"
                                        :options="timeZonesList"
                                        label="label"
                                        track_by="format"
                                        :placeholder="$t('Select Time zone')"
                                        :hideSelected="false"
                                        :close-on-select="true"
                                        deselectLabel=""
                                        selectLabel=""
                                        selectedLabel=""
                                        :showNoOptions="false"
                                        class="align-input-field"
                                        @select="handleTimeZoneSelection($event)"
                                        ref="timeZoneDropdown"
                                        >
                                        <!-- @open="dropDownOpened" -->
                                        <div style="display: inline-block;max-height: 12px;align-items: center;width: 100%;" slot="option" slot-scope="scope">
                                            <div style="float:inline-start">
                                                <span>{{scope.option.label}}</span>
                                            </div>
                                            <span style="color: #a5a5a5;margin-inline-start: 10px;font-size: 12px;">( {{ scope.option.value }} )</span>
                                        </div>
                                        <span slot="noResult">No results.</span>
                                    </Multiselect>
                                </div>
                                <div v-if="isEditting('user_time_zone')" class="d-flex" style="margin-inline-start:10px;align-items:center">
                                    <div class="d-flex">
                                        <save-icon
                                            @click.native="saveditedInfoField('user_time_zone')"
                                        ></save-icon>
                                        <cancel-icon
                                            @click.native="cancelEditedField()"
                                        ></cancel-icon>
                                    </div>
                                </div>
                            </div>
                            <div class="config-desc" style="width: 100%;">
                                {{$t('To set user preferred time zone')}}. Ex: Asia/Kolkata
                            </div>
                        </td>   
                    </tr>
                    <tr class='d-flex'>
                        <td class="key-div">{{$t('Language')}}</td>
                        <td class="value-div w-30 float-left m-0">
                            <div style="display: inline-flex" class="w-100">
                            <div class="w-100">
                                <div class="d-inline-flex" v-if="!isEditting('user_language')">
                                    <span v-show="!isEditting('user_language')">{{selectedLanguage}}</span>
                                    <edit-icon @click.native="editBasicInfoField('user_language')" v-show="!isEditting('user_language')" class="editIcon"></edit-icon>
                                </div>
                                <Multiselect
                                    v-if="isEditting('user_language')"
                                    :value="getLanguageMap(selectedLanguage)"
                                    :options="languagesList"
                                    label="name"
                                    track_by="_id"
                                    :placeholder="$t('Select language')"
                                    :hideSelected="false"
                                    :close-on-select="true"
                                    deselectLabel=""
                                    selectLabel=""
                                    selectedLabel=""
                                    :showNoOptions="false"
                                    class="align-input-field"
                                    @select="handleLanguageSelection($event)"
                                    ref="languagesDropdown"
                                    >
                                    <!-- @open="dropDownOpened" -->
                                    <span slot="noResult">No results.</span>
                                </Multiselect>
                            </div>
                            <div v-if="isEditting('user_language')" class="d-flex" style="margin-inline-start:10px;align-items:center">
                                <div class="d-flex">
                                <save-icon
                                    @click.native="saveditedInfoField('user_language')"
                                ></save-icon>
                                <cancel-icon
                                    @click.native="cancelEditedField()"
                                ></cancel-icon>
                                </div>
                            </div>
                            </div>
                            <div class="config-desc" style="width: 100%;">
                                {{$t('To select User prefered Language')}}
                            </div>
                        </td>   
                    </tr>
                </tbody>
            </table>
        </div>
    </div>   
</template>

<script>

import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import Multiselect from "vue-multiselect";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    components: {
        "edit-icon": EditIcon,
        "save-icon": SaveIcon,
        "cancel-icon": CancelIcon,
        Multiselect
    },
    data(){
        return{
            userInfo: {},
            editingKey: null,
            selectedTimeZoneValue:{},
            timeZonesList:[],
            languagesList:[],
            selectedLanguage:{},
        };
    },

    computed:{
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapGetters("users",["getLoggedInUserInfo","getLoggedInUserId", "getLoggedInUserPrivilege"]),
    },

    created(){
        this.$nextTick(()=>{
            this.selectedTimeZoneValue = this.getStartUpdata().user_time_zone;
            this.selectedLanguage = this.getStartUpdata().user_language;
        });
    
        Object.assign(this.userInfo, this.getLoggedInUserInfo);
        
    },  

    mounted(){
        this.getApplicationTimeZonesDropdownList();
        this.getActiveLanguagesList();
    },

    methods:{
        handleTimeZoneSelection(option){
            if(option){
                this.selectedTimeZoneValue = option.label;
            }
        },

        handleLanguageSelection(option){
            if(option){
                this.selectedLanguage = option.name;
            }
        },

        isEditting(keyName) {
            return keyName === this.editingKey;
        },
        
        editBasicInfoField(keyName) {
            this.editingKey = keyName;
        },

        saveditedInfoField(field){
            let payload = {};
            // payload[field] = this.postData[field]
            if(field == "user_time_zone"){
                payload[field] = this.selectedTimeZoneValue;
            }

            if(field == "user_language"){
                payload[field] = this.selectedLanguage;
            }
            payload.user_preferences = true;
            payload.params = { user_id: this.getLoggedInUserId};
            this.updateLoggedInUserPreferences(payload).then((data)=>{
                if(data.statusCode == 200){
                    this.userInfo[field] = this.selectedTimeZoneValue;
                    this.$toast.success(data.message)
                    this.editingKey = null;
                    this.validPassword = true;
                    this.validEmail = true;
                    this.validNumber = true;
                    this.validCCMailId = true
                    delete this.postData["password"]
                    this.verifiedPassword = "";
                }else{
                    this.$toast.error(data.message);
                    return
                }
            })
        },

        cancelEditedField(){
            this.editingKey = null;
        },

        getStartUpdata(){
            if(typeof this.getStartUpDataFromInCache == "function"){
                return this.getStartUpDataFromInCache()
            }else{
                return this.getStartUpDataFromInCache;
            }
        },

        getApplicationTimeZonesDropdownList(){
            this.getTimezonesDropdownValuesFromServer().then((data)=>{
                this.timeZonesList = data.time_zones;                
            });
        },
        
        getTimeZoneMap(timeZoneValue){
            let timeZoneIndex = this.timeZonesList.findIndex(op=>op.label == timeZoneValue);
            return this.timeZonesList[timeZoneIndex];
        },

        getActiveLanguagesList(){
            // let payload = {};
            let payload = {"enabled":true};
            this.getlangaugesDetailsFromServer(payload).then((data)=>{
                this.languagesList = data["languages"];
            });
        },

        getLanguageMap(languageName){
            let languageIndex = this.languagesList.findIndex((op)=>op.name == languageName);
            return this.languagesList[languageIndex];
        },

        ...mapActions("users", ["updateExistingUser","updateLoggedInUserPreferences"]),
        ...mapActions("settings",["getTimezonesDropdownValuesFromServer", "getlangaugesDetailsFromServer"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    }

}   
</script>
<style scoped lang="scss">
    $header-background: #1a1a1a;
    $background: #121212;
    $body-bg-color: #0d0d0d;
    $options-text-color: #9c9c9c;
    $table-row-border: none;
    $modal-border:1px solid #202020;
    $modal-background: #121212;
    $header-color:#9e9e9e;
    $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $danger-color: #dc3545 !important;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $button-height:38px;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $active-green-icon-color: #00ff3a;
    $learn-about-text-color:#9a9620;
    $readOnly-bg-color: #1e2326 !important;

    .btn{
        font-size:14px !important;
        height:100%;
    }
    .users-basic-info-table {
    tbody {
        margin: 10px;
        .key-div {
        text-align: end;
        color: $dull-text-color;
        }
        .value-div {
        text-align: start;
        margin-inline-start: 10px;
        }
    }
    }
    table {
    background: transparent;
    thead {
        th {
        color: $dull-text-color;
        border-top: $table-row-border !important;
        border-bottom: $table-row-border !important;
        }
    }
    tbody {
        color: $text-color;
        td {
        border-top: $table-row-border !important;
        }
    }
    }
    .validationmessage{
    color:$danger-color;
    font-size: 11px;
    }

    .border{
        border: $border-color !important;
    }

    .activeclass{
        color: $active-blue;
    }

    .modal-header,.modal-footer{
        border: none !important;
        background: $header-background;
        .modal-title{
        color:$header-color;
        }
    }

    ul{
        list-style-type: none;
    }

    .primary-btn-style{
        button{
            height: 35px;
            width: 70px;
        font-size:14px;
        }
    }

    .secondary-btn-style{
    color:$text-color;
    }

    .sidebar{
        background: $background;
        color: $options-text-color;
    }
    .sidebar:hover{
        color: $text-color;
    }
    table.users-basic-info-table .editIcon {
    visibility: hidden;
    }
    table.users-basic-info-table td.value-div:hover .editIcon {
    visibility: visible;
    }
    .editIcon {
    margin-inline-start: 9px;
    }

    .comm-input-field-style{
        background: $primary-background!important;
        // width: 100% !important;
        float: inline-start;
        padding: $input-field-padding;
        border: $border-color!important;
        font-size:$input-field-and-label-font-size;
        height: $input-field-height;
    }

    input[type='checkbox']:after{
        line-height: 1.5em;
        content: '';
        display: inline-block;
        width: 22px;
        height: 21px;
        margin-top: 5px;
        margin-inline-start: -1px;
        border: $border-color;
        border-radius: 0.25em;
        background: $primary-background;
    }

    input[type='checkbox']:checked:after{
        content: '✔';
        color: $active-blue !important;
        // position: absolute;
        font-size: 16px;
        line-height: 1;
        transition: all .2s;
        font-family: Helvetica, Arial, sans-serif;
        padding-inline-start: 4px;
        padding-top:2px;
    }

    .comm-table-styles {
        tbody {
            margin: 10px;
            .key-div {
                text-align: end;
                color: $dull-text-color;
                width:20%;
            }
            .value-div {
                text-align: start;
                margin-inline-start: 10px;
                width: 50%;
                font-weight: 500;
            }
        }
    }

     table.comm-table-styles .editIcon {
        visibility: hidden;
    }
    table.comm-table-styles td.value-div:hover .editIcon {
        visibility: visible;
    }

    .config-desc{
        color: $dull-text-color;
        font-size: 14px;
        margin-top: 1px;
    }

    ::v-deep{

        .multiselect{
            width:100%;
            margin: 3px 0px;
            // display: flex; this is commented bcz if dispalay : flex given then dropdown will be overlap on the feild
        }
        .multiselect__content-wrapper{
            display:none;
        }
        .tags-style{
            margin:5px;
        }
        .multiselect__tag, .tags-style {
            background-color: $primary-background !important;
            border: $border-color;
            border-radius: 5px;
            margin-bottom:0px;
        }
        .multiselect__tags, .tags-style {
            background: $primary-background !important;
            border: $border-color !important;
        }
        .multiselect__option--highlight {
            background: $bg-color-on-hover !important;
        }
        .multiselect__content {
            background: $secondary-background-color !important;
        }
        .multiselect__input, .multiselect__single {
            background: transparent !important;
            color:$text-color;
        }
        .multiselect__input:focus{
            outline:none;
            box-shadow: none;
        }
        .multiselect__tag-icon{
        color:$text-color;
        }
        .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
            background: $bg-color-on-hover !important;
            color: $text-color !important;
        }
        .multiselect__tag-icon:after{
        color:$secondary-text-color !important;
        font-size: 20px;
        }
        .multiselect *{
            font-size: $input-field-and-label-font-size;
            font-family: "Roboto", Arial, sans-serif !important;
        }
        .multiselect__tags{
            display: block;
            align-items: center;
            width: 100%;
            height: 44px !important;
            padding: 5px 40px 0 8px!important;
              .selected-tags-style{
                  margin : 0px !important;
              }
            
        }
        .multiselect__placeholder {
            padding-top: 5px !important;
            margin-bottom:0px;
            color:$dull-text-color !important;
        }
        .multiselect{
            color:$text-color !important;
            font-size: $input-field-and-label-font-size !important;
            min-height: 38px;
        }
        .multiselect__single{
            padding-top:6px !important;
        }
        .multiselect__option--selected{
            background: $bg-color-on-hover !important;
            color: $text-color;
        }
        .multiselect__content-wrapper{
            border: 1px solid $bg-color-on-hover !important;
            position: absolute;
            display: block;
            background: $text-color;
            width: 100%;
            max-height: 150px;
            overflow: auto;
            border: 1px solid $text-color;
            border-top: none;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
            z-index: 50;
            -webkit-overflow-scrolling: touch;
        }
        .multiselect__select,.multiselect__current,.multiselect__option{
            line-height: 12px !important;
        }
        .multiselect--above .multiselect__content-wrapper{
        background: $secondary-background-color !important;
        }
        .multiselect__tags {
            background: $primary-background!important;
            height: auto;
        }

    }  

</style>
